import axios from 'axios';

const UNSPLASH_ACCESS_KEY = 'rHCkWdoQDGxVS6QtVdYnUzHv5Hif2aJm--fE-DYCyN0';

const unsplashApi = axios.create({
  baseURL: 'https://api.unsplash.com',
  headers: {
    Authorization: `Client-ID ${UNSPLASH_ACCESS_KEY}`,
  },
});

export const fetchImage = async (query) => {
  try {
    const response = await unsplashApi.get("/search/photos", {
      params: { query, per_page: 30 }, // Traer 10 imágenes en lugar de 1
    });

    const results = response.data.results;
    if (results.length > 0) {
      // Seleccionar una imagen al azar entre las obtenidas
      const randomIndex = Math.floor(Math.random() * results.length);
      return results[randomIndex].urls.regular;
    }
    
    return ""; // Devolver vacío si no hay resultados
  } catch (error) {
    console.error("Error fetching image from Unsplash:", error);
    return "";
  }
};
